import { Wallpaper } from '../Wallpaper/Wallpaper';
import styles from './layout.module.css'
import { ReactNode } from 'react'

type Props = {
    children: ReactNode
};

export default function Layout({children}: Props){

  return (
    <Wallpaper className={styles.div}>
        {children}
    </Wallpaper>
  )
}
